<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{tituloGrids}}</span>
      </v-col>
       <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs class="py-2 px-0" :items="aItemsBreadcrumbs" divider=">" >
         <template v-slot:item="{ item }">
          <v-breadcrumbs-item class="titlesdark--text">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0" v-if="aInfoTab.length>0">
      <v-col md="12" sm="12" class="pa-0 ma-0 mt-3">
        <v-tabs v-model="nTabSelect" align-with-title dark active-class="active-item" background-color="#161E33" height="36px">
          <v-tabs-slider color="btndest lighten-3"></v-tabs-slider>
          <v-tab v-for="nameTab in aInfoTab" :key="nameTab.titulo" dark>
            {{nameTab.titulo}}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="nTabSelect">
          <v-tab-item v-for="(info, key) in aInfoTab" :key="key">
            <grid
              :ref="`${aRefs[key]}`"
              :tabla="info.tabla"
              :bActiveFilter="true"
              :bActiveExport="true"
              :sIdTable="'idCompromisos_Reunion'"
              :bShowMapDetails="false"
              :bActiveNew="false"
              :aInfoTBDetalleExp="aDetallesExport"
              :aAccionesAdicionales="aAccionesAdicionales[key]"
              @idSelect="getIdSelect"
              @nameField="getNameFieldSelect"
              altoTabla="67vh"
              bGridAnidada
            >
              <template v-slot:slot-grid-anidada="{ item }" >
                <grid-detalle
                  v-if="parseInt(item?.idCompromisos_Reunion) > 0"
                  :tabla="'COPSECANCOL_Compromisos_Historico$1'"
                  :sIdTable="'idHistorico'"
                  :bGridDetalle="true"
                  :nIdValor="parseInt(item?.idCompromisos_Reunion)"
                  :sCampoFiltro="'compromisoid'"
                  :bActiveFilter="false"
                  :bActiveExport="false"
                  :bSingleSelect="false"
                  :bShowSelect="false"
                  :bShowMapDetails="false"
                  :bActiveSearch="false"
                  :bActiveNew="false"
                />
              </template>
            </grid>  
          </v-tab-item>
        </v-tabs-items> 
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import grid from '@/components/Grid/Grid.vue'
import mxFunciones from '@/mixins/funciones.js'
import GridDetalle from '@/components/Grid/Grid.vue'

export default {
  name: 'CompromisosReunion',
  components: {
    grid,
    GridDetalle,
  },
  mixins: [mxFunciones],
  data() {
    return {
      nKeyGeneral:0,
      aTablasDetalles : [
          'COPSECANCOL_Compromisos_Reunion$3', //Sin gestión
          'COPSECANCOL_Compromisos_Reunion$5', //En proceso
          'COPSECANCOL_Compromisos_Reunion$6' //Cerrado 
      ],
      aKeyActualizarTabla:[
        {key:0,bPrimerCarga:true},
        {key:0,bPrimerCarga:true},
        {key:0,bPrimerCarga:true},
      ],
      aRefs:[
        'compSinGestion',
        'compProceso',
        'compCerrado'
      ],
      aInfoTab  : [],
      nIdSeleccionado  : 0,                 // Id seleccionado
      sNombreCampoFiltro : '',                 // Nombre del campo foreignKey
      mostrarFormularioNuevo : false,
      nKeyReset : 0,
      aItemsBreadcrumbs: [
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlInicio,
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlModuloOperaciones,
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: '',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
      ],
      aDetallesExport : [
        { 
          sTablaDetalle: 'COPSECANCOL_Compromisos_Historico',
          sNombreCampoFiltroDetalle: 'compromisoid',
          sCampoParaFiltroTBPrincipal: 'idCompromisos_Reunion',
        }
      ],
      aAccionesAdicionales: [
        [
          {
            componente: 'BtneGestionar',
            mensaje: this.$store.state.jsIdioma.oEquivalencias.btnGestionar,
            oProps: {
              sTablaFormulario: 'COPSECANCOL_Compromisos_Historico',
              sDetalleTitulo: 'Información de Compromiso',
              bDetalleFormulario: true,
              aParametrosEnvio: [
                {
                  sParametro: 'compromisoid',
                  sCampoExtraer: 'idCompromisos_Reunion' // Indica que para extraer es de una manera diferente que la que muestra

                },
              ]
            }
          }
        ],
        [
          {
            componente: 'BtneGestionar',
            mensaje: this.$store.state.jsIdioma.oEquivalencias.btnGestionar,
            oProps: {
              sTablaFormulario: 'COPSECANCOL_Compromisos_Historico',
              sDetalleTitulo: 'Información de Compromiso',
              bDetalleFormulario: true,
              aParametrosEnvio: [
                {
                  sParametro: 'compromisoid',
                  sCampoExtraer: 'idCompromisos_Reunion' // Indica que para extraer es de una manera diferente que la que muestra

                },
              ]
            }
          }
        ],
        [
          {
            componente: 'BtneGestionar',
            mensaje: this.$store.state.jsIdioma.oEquivalencias.btnGestionar,
            oProps: {
              sTablaFormulario: 'COPSECANCOL_Compromisos_Reunion$6',
              sDetalleTitulo: 'Información de Compromiso cerrado',
              bDetalleFormulario: true,
              aParametrosEnvio: [
                {
                  sParametro: 'compromisoid',
                  sCampoExtraer: 'idCompromisos_Reunion' // Indica que para extraer es de una manera diferente que la que muestra

                },
              ]
            }
          }
        ]
      ],
      nTabSelect : 0,
    }
  },
  async created() {
    this.onValidarTokenSinLogin()
    await this.onCargarTablas();
    
  },
  methods: {
    onActualizarTablas(){
      for (let i = 0; i < this.aKeyActualizarTabla.length; i++) {
        this.aKeyActualizarTabla[i].key++;
      }
    },
    async onCargarTablas(){

      for (let i = 0; i < this.aTablasDetalles.length; i++) {
        let nombreTabla = await this.getTitulo(this.aTablasDetalles[i])
        await this.aInfoTab.push({
          titulo:nombreTabla,
          tabla:this.aTablasDetalles[i]
        })
        this.tituloGrids = this.aInfoTab[0].titulo
        this.aItemsBreadcrumbs[2].text = this.tituloGrids
        
      }
      
      // await this.aTablasDetalles.forEach(async TablaDetalle => {
      //   let nombreTabla = await this.getTitulo(TablaDetalle)
      //   // let posTabla = this.aTablasDetalles.indexOf(TablaDetalle)
      //   await this.aInfoTab.push({
      //     titulo:nombreTabla,
      //     tabla:TablaDetalle
      //   })
      //   this.tituloGrids = this.aInfoTab[0].titulo
      //   this.aItemsBreadcrumbs[2].text = this.tituloGrids
      // })
    },
    getIdSelect(sIdSelected) {
      this.nIdSeleccionado = sIdSelected;
    },
    getNameFieldSelect(sNameFiled) {
      this.sNombreCampoFiltro = sNameFiled;
    },
  },
  watch:{
    nTabSelect(newvalor){
      this.tituloGrids = this.aInfoTab[newvalor].titulo
      this.aItemsBreadcrumbs[2].text = this.tituloGrids
      // this.aKeyActualizarTabla[newvalor].key++;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>